import { useSearchParams } from 'react-router-dom'
import { IntegrationServiceId } from '../../../../common/integrations'
import { validateAndGetInternalRedirectUrl } from '../../../../common/internalRedirect'
import { SmartOfficeCredentialsModal } from './SmartOffice/SmartOfficeCredentialsModal'
import { RedtailCredentialsModal } from './Redtail/RedtailCredentialsModal'
import { ExchangeCredentialsModal } from './Exchange/ExchangeCredentialsModal'
import { ClaimPhoneNumberPage } from './Phone/models'
import { SmartOfficeIntegrationPrefillData } from './SmartOffice/model'
import { ClaimPhoneNumberModal } from './Phone/ClaimPhoneNumberModal'
import { LinkNewEmailModal } from './DelegatedEmail/LinkNewEmailModal'
import { ConquestPlanningCredentialsModal } from './Conquest/ConquestPlanningCredentialsModal'

interface ModalIntegrationConnectorProps {
  serviceId: IntegrationServiceId
  startConnect: boolean
  onConnected: () => void
  postConnectRedirectPath?: string
}

export const ModalIntegrationConnector: React.FC<ModalIntegrationConnectorProps> = ({
  serviceId,
  startConnect = false,
  onConnected,
  postConnectRedirectPath,
}) => {
  const [searchParams] = useSearchParams()

  const handleSave = () => {
    onConnected()
    if (postConnectRedirectPath) {
      const redirectUrl = validateAndGetInternalRedirectUrl(postConnectRedirectPath)
      if (redirectUrl) {
        window.location.href = redirectUrl
      } else {
        console.error('Invalid postConnectRedirectPath, skipping redirect')
      }
    }
  }

  switch (serviceId) {
    case IntegrationServiceId.PHONE: {
      const initialPage: ClaimPhoneNumberPage | undefined = startConnect ? ClaimPhoneNumberPage.PHONE_NUMBER : undefined
      return <ClaimPhoneNumberModal show={startConnect} onHide={onConnected} page={initialPage} />
    }
    case IntegrationServiceId.EXCHANGE_CALENDAR:
    case IntegrationServiceId.EXCHANGE_MAIL: {
      return (
        <ExchangeCredentialsModal
          serviceId={serviceId}
          show={startConnect}
          onSave={handleSave}
          onCancel={onConnected}
          postConnectRedirectPath={postConnectRedirectPath}
        />
      )
    }
    case IntegrationServiceId.REDTAIL: {
      return <RedtailCredentialsModal show={startConnect} onSave={handleSave} onCancel={onConnected} />
    }
    case IntegrationServiceId.SMARTOFFICE: {
      const encodedSiteName = searchParams.get('siteName')
      const encodedOfficeName = searchParams.get('officeName')
      const encodedUserName = searchParams.get('userName')
      const prefillData: SmartOfficeIntegrationPrefillData | undefined =
        encodedSiteName && encodedOfficeName && encodedUserName
          ? {
              siteName: window.atob(encodedSiteName),
              officeName: window.atob(encodedOfficeName),
              username: window.atob(encodedUserName),
            }
          : undefined

      return <SmartOfficeCredentialsModal show={startConnect} onSave={handleSave} onCancel={onConnected} prefillData={prefillData} />
    }
    case IntegrationServiceId.DELEGATED_EMAIL:
      return startConnect ? <LinkNewEmailModal onHide={onConnected} /> : null
    case IntegrationServiceId.CONQUEST_PLANNING: {
      return <ConquestPlanningCredentialsModal show={startConnect} onSave={onConnected} onCancel={onConnected} />
    }
    default:
      return null
  }
}
